import dataProvider from './dataProvider';

export const setPassword = params =>
    dataProvider.create('users/set-password', { data: params });